module.exports = __webpack_public_path__ + "static/media/tour-2.65846303.jpg";